import { useEffect } from 'react'
import { Toaster } from 'sonner'
import { AppRouter } from './router'
import { UserProfileProvider } from './context/UserProfileContext'
import { initializeTokenRefresh } from './utils/tokenRefreshService'
import { PWAInstallPrompt } from './components/PWAInstallPrompt'
import './App.css'

function App() {
  useEffect(() => {
    // Initialize automatic token refresh on app load
    initializeTokenRefresh()
  }, [])

  return (
    <UserProfileProvider>
      <AppRouter />
      <Toaster position='top-right' richColors />
      <PWAInstallPrompt />
    </UserProfileProvider>
  )
}

export default App
